import { DatePipe } from "@angular/common";
import { Component } from "@angular/core";
import { UserModel } from "app/_models/user-model";
import { NotificationService } from "app/_services/notification.service";
import { SpreadsheetValidateService } from "app/_services/spreadsheetValidation.service";
import { AssetUserService } from "app/_services/asset-user.service";
import { CommonservicesService } from "app/_services/commonservices.service";
import { SpreadsheetFileHandler } from "app/core/handlers/spreadsheet-file-handler";

@Component({
  selector: "app-bulk-assetuser",
  templateUrl: "./bulk-assetuser.component.html",
  styleUrls: ["./bulk-assetuser.component.css"],
})
export class BulkAssetuserComponent extends SpreadsheetFileHandler {
  currentUser: UserModel;
  isLoaderResult: boolean = false;
  file: File;
  uploadFileName: string;
  uploadFileContent: string;
  isAdminGroupUser: boolean = false;

  constructor(
    protected spreadsheetService: SpreadsheetValidateService,
    protected datePipe: DatePipe,
    protected readonly notify: NotificationService,
    private readonly assetUserService: AssetUserService,
    private readonly commonService: CommonservicesService
  ) {
    super(spreadsheetService, datePipe, notify);
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  downLoadFile(): void {
    this.downloadFileHelper(
      this.assetUserService.getSampleBulkAssetUserFile(),
      "SampleBulkAssetUser"
    );
  }

  uploadedFile(event: any): void {
    this.handleFileUpload(
      event,
      (file) => this.uploadToAPI(file),
      "upload_bulkAssetUser"
    );
  }

  uploadToAPI(file: File): void {
    this.uploadFileHelper(
      (formData) =>
        this.assetUserService.uploadFileToBulkCreateAssetUsers(formData),
      file,
      (fileName) => this.downloadResultFile(fileName)
    );
  }

  downloadResultFile(fileName: string): void {
    this.downloadResultFileHelper(
      this.commonService.getResultFileByFileName(fileName),
      fileName,
      "Bulk asset users creation result file download process started.",
      "Error in downloading the bulk asset users creation file"
    );
  }
}
